import { render, staticRenderFns } from "./AlignmentPicker.vue?vue&type=template&id=6b78b7f5&"
import script from "./AlignmentPicker.vue?vue&type=script&lang=js&"
export * from "./AlignmentPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports